import React from "react";
import { Form, Typography } from "antd";
import { getFormItemLabel } from "../util/helpers";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
const { Text } = Typography;

const ReadOnlyItem = (props) => {
  const { name, category, content } = props;
  const intl = useIntl();
  const label = getFormItemLabel(intl, category, name, null);
  return (
    <Form.Item label={label} name={name}>
      <div
        style={{
          borderRadius: "5px",
          border: "dashed 1px rgba(120, 120, 120, 0.32)",
          backgroundColor: "rgba(230, 230, 230, 0.14)",
          padding: "0 11px",
          height: "30px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Text ellipsis>{content}</Text>
      </div>
    </Form.Item>
  );
};

ReadOnlyItem.propTypes = {
  name: PropTypes.string,
  category: PropTypes.string,
};

export default ReadOnlyItem;
